import { useTranslation } from 'react-i18next';
import { Link } from './StyledComponents.jsx';
import { Dialog, Text, Flex } from '@radix-ui/themes';
import { CreateAccountModal } from '../../../shared/SignIn/CreateAccountModal.jsx';
import { SignInModal } from '../../../shared/SignIn/SignInModal.jsx';

import styles from '../header.module.css';

const parseUrlParams = () => {
  const url = new URL(window.location.href);
  const params = {};

  // Check for tile_id
  const tileId = url.searchParams.get('tile_id');
  if (tileId) {
    params.tileId = tileId;
  }

  // Check for campaign_id
  const campaignId = url.searchParams.get('campaign_id');
  if (campaignId) {
    params.campaignId = campaignId;
  }

  return params;
};

const GuestOptions = ({
  guestUserResetPath,
  shouldConvertGuest,
  hideSignIn,
}) => {
  const { t } = useTranslation('header');
  const urlParams = parseUrlParams();
  return (
    <Flex direction="column" justify="center" gap="2" p="4">
      <Link
        href={guestUserResetPath}
        id="guestUserConversion"
        data-method="patch"
      >
        <Text className={styles.mobileMenuOption}>
          {t('guestButtons.startOver')}
        </Text>
      </Link>
      {shouldConvertGuest === 'true' && (
        <Dialog.Root>
          <Dialog.Trigger>
            <Text className={styles.mobileMenuOption}>
              {t('guestButtons.createAccount')}
            </Text>
          </Dialog.Trigger>
          <CreateAccountModal redirectParam={urlParams} />
        </Dialog.Root>
      )}
      {hideSignIn !== 'true' && (
        <Dialog.Root>
          <Dialog.Trigger>
            <Text className={styles.mobileMenuOption}>
              {t('guestButtons.signIn')}
            </Text>
          </Dialog.Trigger>
          <SignInModal redirectParam={urlParams} />
        </Dialog.Root>
      )}
    </Flex>
  );
};

export default GuestOptions;
